import { render } from "./StatsBuilderAddRowModal.vue?vue&type=template&id=10eba7c5&scoped=true"
import script from "./StatsBuilderAddRowModal.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderAddRowModal.vue?vue&type=script&lang=ts"

import "./StatsBuilderAddRowModal.vue?vue&type=style&index=0&id=10eba7c5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10eba7c5"

export default script